import React from 'react';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Login from '../common/login';

const cookies = new Cookies();

/* الخادم ينتظر DD/MM/YYYY — صيغة محلية بدل moment
   تجنّباً لاختلاف interop بين webpack و babel على `import * as` */
const fmtDate = (d) => {
    const x = (d instanceof Date) ? d : new Date(d);
    if (isNaN(x.getTime())) return '';
    const p = n => (n < 10 ? '0' : '') + n;
    return `${p(x.getDate())}/${p(x.getMonth() + 1)}/${x.getFullYear()}`;
};

/* ── فلاتر الحالة ────────────────────────────────────────── */
const STATUS_OPTIONS = [
    { key: 'all', label: 'الكل عدا الملغي', hint: 'status ≠ 2' },
    { key: 'delivering', label: 'قيد التوصيل', hint: 'status = 1' },
    { key: 'returned', label: 'راجع', hint: 'status = 4' },
    { key: 'prepared', label: 'تم تجهيزها', hint: 'status = 1 + 4' },
    { key: 'cancelled', label: 'الملغي', hint: 'status = 2' }
];

const REPLACEMENT_OPTIONS = [
    { key: 'all', label: 'مع الاستبدالات' },
    { key: 'only', label: 'الاستبدالات فقط' },
    { key: 'none', label: 'بدون استبدالات' }
];

/* ── لوحة الألوان ────────────────────────────────────────── */
const C = {
    canvas: '#eef2f7',
    surface: '#ffffff',
    line: '#dfe6ee',
    ink: '#0f172a',
    muted: '#64748b',
    sells: '#0284c7',
    cost: '#d97706',
    spend: '#dc2626',
    profit: '#059669',
    net: '#4f46e5'
};

const EMPTY = {
    items: [], items_sum: 0, order_count: 0, returned_count: 0, delivered_count: 0,
    prepared_count: 0, replacement_count: 0, return_rate: null, return_share: null,
    rate_applicable: false, price_sum: 0, shipping_total: 0, companies: [],
    sells: 0, items_cost: 0, spending_total: 0, spending_groups: [], gross_profit: 0, profit: 0
};

class OrdersReports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            from: new Date(),
            to: new Date(),
            page: 'All',
            company: 'All',
            status: 'all',
            replacement: 'all',
            shipB: '3.5',
            shipO: '3.5',
            shipPrices: {},   // { "اسم الشركة": { b: "4", o: "6" } }
            pages: [],
            shiper: [],
            loading: false,
            searched: false,
            error: '',
            data: EMPTY,
            sortKey: 'count',
            sortDir: 'desc'
        };
    }

    headers = () => ({ "Content-Type": "application/json", token: cookies.get("token") });

    componentDidMount() {
        axios.get(`${host}dashbord/shiper/all/`, { headers: this.headers() })
            .then(res => this.setState({ shiper: res.data.shiper || [] }))
            .catch(() => { });

        axios.get(`${host}users/pages/name/all`, { headers: this.headers() })
            .then(res => this.setState({ pages: (res.data.data && res.data.data.pages) || [] }))
            .catch(() => { });
    }

    search = () => {
        const { from, to, page, company, status, replacement, shipB, shipO, shipPrices } = this.state;
        const d1 = fmtDate(from);
        const d2 = fmtDate(to);

        this.setState({ loading: true, error: '' });

        // أسعار الشركات المعروفة تُرسل للخادم حتى تتطابق أرقامه مع الشاشة
        const shipPayload = {};
        Object.keys(shipPrices).forEach(k => {
            shipPayload[k] = { b: Number(shipPrices[k].b) || 0, o: Number(shipPrices[k].o) || 0 };
        });

        const url = `${host}users/orders/reports/full`
            + `?from=${d1}&to=${d2}`
            + `&page=${encodeURIComponent(page)}`
            + `&company=${encodeURIComponent(company)}`
            + `&status=${status}&replacement=${replacement}`
            + `&b_price=${shipB}&other_price=${shipO}`
            + `&ship=${encodeURIComponent(JSON.stringify(shipPayload))}`;

        axios.get(url, { headers: this.headers() })
            .then(res => {
                const d = res.data.data || EMPTY;

                // شركات جديدة تظهر لأول مرة تأخذ الافتراضي؛ تعديلاتك السابقة تبقى
                const next = Object.assign({}, this.state.shipPrices);
                (d.companies || []).forEach(c => {
                    if (!next[c.name]) {
                        next[c.name] = { b: String(c.b_price), o: String(c.other_price) };
                    }
                });

                this.setState({ data: d, shipPrices: next, searched: true, loading: false });
            })
            .catch(err => {
                const msg = (err.response && err.response.data && err.response.data.message)
                    || 'تعذّر جلب التقرير. تأكد من الاتصال وأعد المحاولة.';
                this.setState({ loading: false, error: msg });
            });
    };

    /* ── إعادة الحساب محلياً وأنت تعدّل الأسعار ─────────────
       الحساب حسابي بحت من أعداد الطلبات، فنتيجته مطابقة
       للخادم بالضبط ولا تحتاج نداءً جديداً. */
    computed = () => {
        const d = this.state.data;
        const prices = this.state.shipPrices;
        const round2 = n => Math.round(n * 100) / 100;

        const rows = (d.companies || []).map(c => {
            const p = prices[c.name] || { b: c.b_price, o: c.other_price };
            const b = Number(p.b) || 0;
            const o = Number(p.o) || 0;
            const shipping = round2(c.baghdad * b + c.other * o);
            return Object.assign({}, c, {
                b_price: b, other_price: o, shipping,
                sells: round2(c.price_sum - shipping)
            });
        });

        const shipping_total = round2(rows.reduce((s, c) => s + c.shipping, 0));
        const price_sum = Number(d.price_sum) || 0;
        const sells = round2(price_sum - shipping_total);
        const items_cost = Number(d.items_cost) || 0;
        const spending_total = Number(d.spending_total) || 0;

        return Object.assign({}, d, {
            companies: rows,
            shipping_total,
            sells,
            gross_profit: round2(sells - items_cost),
            profit: round2(sells - items_cost - spending_total)
        });
    };

    setCompanyPrice = (name, field, value) => {
        this.setState(s => {
            const next = Object.assign({}, s.shipPrices);
            const cur = next[name] || { b: s.shipB, o: s.shipO };
            next[name] = Object.assign({}, cur, { [field]: value });
            return { shipPrices: next };
        });
    };

    applyDefaultToAll = () => {
        this.setState(s => {
            const next = {};
            (s.data.companies || []).forEach(c => {
                next[c.name] = { b: s.shipB, o: s.shipO };
            });
            return { shipPrices: next };
        });
    };

    num = (v, dec) => {
        const n = Number(v) || 0;
        return n.toLocaleString('en-US', {
            minimumFractionDigits: dec === undefined ? 0 : dec,
            maximumFractionDigits: dec === undefined ? 2 : dec
        });
    };

    sortedItems = () => {
        const { data, sortKey, sortDir } = this.state;
        const rows = (data.items || []).map((it, i) => ({
            i: i + 1,
            name: it.name || '—',
            count: Number(it.count) || 0,
            dw_price: Number(it.dw_price) || 0
        }));
        rows.sort((a, b) => {
            let r;
            if (sortKey === 'name') r = String(a.name).localeCompare(String(b.name), 'ar');
            else r = a[sortKey] - b[sortKey];
            return sortDir === 'asc' ? r : -r;
        });
        return rows;
    };

    toggleSort = (key) => {
        this.setState(s => ({
            sortKey: key,
            sortDir: s.sortKey === key && s.sortDir === 'desc' ? 'asc' : 'desc'
        }));
    };

    /* ── مجموعات صغيرة للعرض ─────────────────────────────── */
    renderChips(options, current, onPick, name) {
        return (
            <div className="chip-row" role="group" aria-label={name}>
                {options.map(o => (
                    <button
                        key={o.key}
                        type="button"
                        onClick={() => onPick(o.key)}
                        className={"chip" + (current === o.key ? " chip-on" : "")}
                        title={o.hint || o.label}
                    >
                        {o.label}
                    </button>
                ))}
            </div>
        );
    }

    renderKpi(d) {
        const profit = Number(d.profit) || 0;
        const cards = [
            { key: 'sells', label: 'المبيعات', value: d.sells, color: C.sells, sub: 'بعد خصم أجور التوصيل' },
            { key: 'cost', label: 'التكاليف', value: d.items_cost, color: C.cost, sub: 'كلفة المواد الفعلية' },
            { key: 'spend', label: 'المصاريف', value: d.spending_total, color: C.spend, sub: 'كل مصاريف المدة' },
            {
                key: 'profit', label: 'الأرباح', value: profit,
                color: profit < 0 ? C.spend : C.profit,
                sub: 'المبيعات − التكاليف − المصاريف'
            }
        ];
        return (
            <div className="kpi-grid">
                {cards.map(c => (
                    <div key={c.key} className="kpi" style={{ borderTopColor: c.color }}>
                        <span className="kpi-label">{c.label}</span>
                        <strong className="kpi-value" style={{ color: c.color }}>{this.num(c.value)}</strong>
                        <span className="kpi-sub">{c.sub}</span>
                    </div>
                ))}
            </div>
        );
    }

    /* الشريط: يفكّك المبيعات إلى تكاليف · مصاريف · ربح */
    renderBreakdown(d) {
        const sells = Number(d.sells) || 0;
        if (sells <= 0) return null;

        const cost = Math.max(Number(d.items_cost) || 0, 0);
        const spend = Math.max(Number(d.spending_total) || 0, 0);
        const profit = Number(d.profit) || 0;
        const gross = Number(d.gross_profit) || 0;
        const total = cost + spend + Math.max(profit, 0);
        if (total <= 0) return null;

        const pct = v => Math.max((v / total) * 100, 0);
        const segs = [
            { label: 'التكاليف', value: cost, color: C.cost },
            { label: 'المصاريف', value: spend, color: C.spend },
            { label: 'الأرباح', value: Math.max(profit, 0), color: C.profit }
        ];

        return (
            <div className="panel breakdown">
                <div className="panel-head">
                    <h3>تفكيك المبيعات</h3>
                    <span className="panel-note">
                        مجمل الربح قبل المصاريف: <b style={{ color: gross < 0 ? C.spend : C.net }}>{this.num(gross)}</b>
                    </span>
                </div>

                <div className="bar" aria-hidden="true">
                    {segs.map(s => s.value > 0 ? (
                        <span key={s.label} style={{ width: pct(s.value) + '%', background: s.color }} />
                    ) : null)}
                </div>

                <div className="legend">
                    {segs.map(s => (
                        <span key={s.label} className="legend-item">
                            <i style={{ background: s.color }} />
                            {s.label}
                            <b>{this.num(s.value)}</b>
                            <em>{total > 0 ? Math.round(pct(s.value)) + '%' : '0%'}</em>
                        </span>
                    ))}
                </div>

                {profit < 0 && (
                    <p className="warn">
                        خسارة {this.num(Math.abs(profit))} — التكاليف والمصاريف تجاوزت المبيعات في هذه المدة.
                    </p>
                )}
            </div>
        );
    }

    renderMeta(d) {
        const bits = [
            { label: 'عدد الطلبات', value: this.num(d.order_count) },
            { label: 'عدد القطع', value: this.num(d.items_sum) },
            { label: 'الواصل', value: this.num(d.delivered_count) },
            { label: 'الراجع', value: this.num(d.returned_count) },
            { label: 'طلبات الاستبدال', value: this.num(d.replacement_count) }
        ];
        return (
            <div className="meta-row">
                {bits.map(b => (
                    <div key={b.label} className="meta">
                        <span>{b.label}</span>
                        <strong>{b.value}</strong>
                    </div>
                ))}
            </div>
        );
    }

    /* أجور التوصيل لكل شركة ظهرت في المدة */
    renderCompanies(d) {
        const rows = d.companies || [];
        if (!rows.length) return null;

        return (
            <div className="panel ships">
                <div className="panel-head">
                    <h3>أجور التوصيل حسب الشركة</h3>
                    <button type="button" className="mini-btn" onClick={this.applyDefaultToAll}>
                        طبّق الافتراضي على الكل
                    </button>
                </div>

                <p className="hint top-hint">
                    عدّل السعر وتتحدّث المبيعات والأرباح فوراً بلا إعادة بحث.
                </p>

                <div className="ship-head">
                    <span>الشركة</span>
                    <span>الطلبات</span>
                    <span>بغداد</span>
                    <span>المحافظات</span>
                    <span>أجرة بغداد</span>
                    <span>أجرة المحافظات</span>
                    <span>مجموع الأجور</span>
                </div>

                {rows.map(c => {
                    const p = this.state.shipPrices[c.name] || { b: c.b_price, o: c.other_price };
                    return (
                        <div key={c.name} className="ship-row">
                            <span className="ship-name" data-l="الشركة">{c.name}</span>
                            <span className="ship-n" data-l="الطلبات">{this.num(c.orders)}</span>
                            <span className="ship-n" data-l="بغداد">{this.num(c.baghdad)}</span>
                            <span className="ship-n" data-l="المحافظات">{this.num(c.other)}</span>
                            <span data-l="أجرة بغداد">
                                <input
                                    type="number" step="0.25" min="0" className="inp small"
                                    value={p.b}
                                    aria-label={`أجرة بغداد لشركة ${c.name}`}
                                    onChange={e => this.setCompanyPrice(c.name, 'b', e.target.value)}
                                />
                            </span>
                            <span data-l="أجرة المحافظات">
                                <input
                                    type="number" step="0.25" min="0" className="inp small"
                                    value={p.o}
                                    aria-label={`أجرة المحافظات لشركة ${c.name}`}
                                    onChange={e => this.setCompanyPrice(c.name, 'o', e.target.value)}
                                />
                            </span>
                            <span className="ship-total" data-l="مجموع الأجور">{this.num(c.shipping)}</span>
                        </div>
                    );
                })}

                <div className="ship-sum">
                    <span>إجمالي الأسعار قبل الخصم <b>{this.num(d.price_sum)}</b></span>
                    <span>مجموع أجور التوصيل <b>{this.num(d.shipping_total)}</b></span>
                    <span>المبيعات <b style={{ color: C.sells }}>{this.num(d.sells)}</b></span>
                </div>
            </div>
        );
    }

    /* نسبة الراجع — تظهر فقط حين يكون المقام حقيقياً */
    renderReturnRate(d) {
        if (!d.rate_applicable) return null;

        const delivered = Number(d.delivered_count) || 0;
        const returned = Number(d.returned_count) || 0;
        const rate = d.return_rate;
        const share = d.return_share;

        if (delivered === 0 && returned === 0) return null;

        // لون تحذيري كلما ارتفعت النسبة
        const r = Number(rate);
        const tone = (rate === null || rate === undefined) ? C.muted
            : r >= 25 ? C.spend : r >= 12 ? C.cost : C.profit;

        const shareNum = Number(share) || 0;

        return (
            <div className="panel rate">
                <div className="panel-head">
                    <h3>نسبة الراجع للواصل</h3>
                    <span className="panel-note">
                        {returned} راجع مقابل {delivered} واصل
                    </span>
                </div>

                <div className="rate-body">
                    <div className="rate-figure">
                        <strong style={{ color: tone }}>
                            {(rate === null || rate === undefined) ? '—' : this.num(rate) + '%'}
                        </strong>
                        <span>الراجع ÷ الواصل</span>
                    </div>

                    <div className="rate-side">
                        <div className="rate-bar" aria-hidden="true">
                            <span style={{ width: Math.min(shareNum, 100) + '%', background: tone }} />
                        </div>
                        <p className="rate-note">
                            {(share === null || share === undefined)
                                ? 'لا توجد طلبات مجهّزة في هذه المدة.'
                                : `الراجع يمثّل ${this.num(share)}% من الطلبات المجهّزة (${this.num(d.prepared_count)} طلب).`}
                        </p>
                    </div>
                </div>

                {(rate === null || rate === undefined) && delivered === 0 && returned > 0 && (
                    <p className="warn">لا يوجد واصل في هذه المدة، فالنسبة غير قابلة للحساب.</p>
                )}
            </div>
        );
    }

    renderItems() {
        const rows = this.sortedItems();
        const { sortKey, sortDir } = this.state;
        const arrow = k => sortKey === k ? (sortDir === 'desc' ? ' ▾' : ' ▴') : '';

        if (!rows.length) {
            return (
                <div className="panel">
                    <div className="panel-head"><h3>القطع المباعة</h3></div>
                    <p className="empty">لا توجد قطع ضمن هذه الفلاتر. وسّع المدة أو غيّر الحالة.</p>
                </div>
            );
        }

        return (
            <div className="panel">
                <div className="panel-head">
                    <h3>القطع المباعة</h3>
                    <span className="panel-note">{rows.length} صنف</span>
                </div>

                <div className="table-wrap">
                    <table className="tbl">
                        <thead>
                            <tr>
                                <th style={{ width: 56 }}>#</th>
                                <th className="sortable" onClick={() => this.toggleSort('name')}>الصنف{arrow('name')}</th>
                                <th className="sortable num" onClick={() => this.toggleSort('count')}>العدد{arrow('count')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, idx) => (
                                <tr key={r.name + idx}>
                                    <td className="dim">{idx + 1}</td>
                                    <td>{r.name}</td>
                                    <td className="num strong">{this.num(r.count)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="card-list">
                    {rows.map((r, idx) => (
                        <div key={r.name + idx} className="mini">
                            <span className="mini-name">{r.name}</span>
                            <span className="mini-count">{this.num(r.count)}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    renderSpending(d) {
        const groups = d.spending_groups || [];
        const max = groups.reduce((m, g) => Math.max(m, Number(g.amount) || 0), 0);

        return (
            <div className="panel">
                <div className="panel-head">
                    <h3>المصاريف حسب التسمية</h3>
                    <span className="panel-note">المجموع {this.num(d.spending_total)}</span>
                </div>

                {!groups.length ? (
                    <p className="empty">لا مصاريف مسجّلة في هذه المدة.</p>
                ) : (
                    <div className="spend-list">
                        {groups.map((g, i) => (
                            <div key={g.name + i} className="spend">
                                <div className="spend-top">
                                    <span className="spend-name">{g.name}</span>
                                    <span className="spend-amount">{this.num(g.amount)}</span>
                                </div>
                                <div className="spend-bar">
                                    <span style={{ width: (max > 0 ? (Number(g.amount) / max) * 100 : 0) + '%' }} />
                                </div>
                                <span className="spend-count">{g.count} سطر</span>
                            </div>
                        ))}
                    </div>
                )}

                <p className="hint">
                    المصاريف تتبع التاريخ فقط — جدول <code>spending</code> غير مرتبط بالصفحة أو بشركة التوصيل.
                </p>
            </div>
        );
    }

    render() {
        if (!cookies.get("token")) return <Login />;
        const { loading, searched, error } = this.state;
        const data = searched ? this.computed() : EMPTY;

        return (
            <div className="orep">
                <style>{CSS}</style>

                <div className="shell">
                    <header className="head">
                        <div>
                            <h1>تقارير الطلبات</h1>
                            <p>المبيعات والتكاليف والمصاريف والأرباح لمدة محددة</p>
                        </div>
                        <button className="back" onClick={() => window.history.back()}>رجوع</button>
                    </header>

                    {/* ── الفلاتر ─────────────────────────────── */}
                    <section className="panel filters">
                        <div className="f-grid">
                            <label className="field">
                                <span>من تاريخ</span>
                                <DatePicker
                                    selected={this.state.from}
                                    onChange={date => this.setState({ from: date })}
                                    dateFormat="dd/MM/yyyy"
                                    className="inp"
                                />
                            </label>

                            <label className="field">
                                <span>إلى تاريخ</span>
                                <DatePicker
                                    selected={this.state.to}
                                    onChange={date => this.setState({ to: date })}
                                    dateFormat="dd/MM/yyyy"
                                    className="inp"
                                />
                            </label>

                            <label className="field">
                                <span>الصفحة</span>
                                <select
                                    className="inp"
                                    value={this.state.page}
                                    onChange={e => this.setState({ page: e.target.value })}
                                >
                                    <option value="All">كل الصفحات</option>
                                    {this.state.pages.map(p => (
                                        <option key={p.id} value={p.id}>{p.name}</option>
                                    ))}
                                </select>
                            </label>

                            <label className="field">
                                <span>المندوب</span>
                                <select
                                    className="inp"
                                    value={this.state.company}
                                    onChange={e => this.setState({ company: e.target.value })}
                                >
                                    <option value="All">كل المندوبين</option>
                                    {this.state.shiper.map(s => (
                                        <option key={s.name} value={s.name}>{s.name}</option>
                                    ))}
                                </select>
                            </label>

                            <label className="field">
                                <span>أجرة بغداد (افتراضية)</span>
                                <input
                                    type="number" step="0.25" min="0" className="inp"
                                    value={this.state.shipB}
                                    onChange={e => this.setState({ shipB: e.target.value })}
                                />
                            </label>

                            <label className="field">
                                <span>أجرة المحافظات (افتراضية)</span>
                                <input
                                    type="number" step="0.25" min="0" className="inp"
                                    value={this.state.shipO}
                                    onChange={e => this.setState({ shipO: e.target.value })}
                                />
                            </label>
                        </div>

                        <div className="f-chips">
                            <div>
                                <span className="f-title">حالة الطلب</span>
                                {this.renderChips(STATUS_OPTIONS, this.state.status,
                                    k => this.setState({ status: k }), 'حالة الطلب')}
                            </div>
                            <div>
                                <span className="f-title">الاستبدالات</span>
                                {this.renderChips(REPLACEMENT_OPTIONS, this.state.replacement,
                                    k => this.setState({ replacement: k }), 'الاستبدالات')}
                            </div>
                        </div>

                        <button className="go" onClick={this.search} disabled={loading}>
                            {loading ? <i className="spinner" /> : null}
                            {loading ? 'جاري الحساب…' : 'عرض التقرير'}
                        </button>

                        {error ? <p className="err">{error}</p> : null}
                    </section>

                    {/* ── النتائج ─────────────────────────────── */}
                    {searched ? (
                        <div className="results">
                            {this.renderKpi(data)}
                            {this.renderMeta(data)}
                            {this.renderCompanies(data)}
                            {this.renderReturnRate(data)}
                            {this.renderBreakdown(data)}
                            {this.renderItems()}
                            {this.renderSpending(data)}
                        </div>
                    ) : (
                        <div className="panel start">
                            <p>اختر المدة والفلاتر ثم اضغط «عرض التقرير».</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

/* ══════════════════════════════════════════════════════════ */
const CSS = `
.orep {
  direction: rtl;
  min-height: 100vh;
  background: ${C.canvas};
  padding: clamp(12px, 3vw, 28px);
  font-family: "Segoe UI", Tahoma, Arial, sans-serif;
  color: ${C.ink};
}
.orep .shell { max-width: 1280px; margin: 0 auto; }

.orep .head {
  display: flex; align-items: flex-start; justify-content: space-between;
  gap: 16px; flex-wrap: wrap; margin-bottom: 18px;
}
.orep .head h1 {
  margin: 0; font-size: clamp(20px, 4vw, 28px); font-weight: 800; letter-spacing: -.3px;
}
.orep .head p { margin: 6px 0 0; color: ${C.muted}; font-size: 14px; }
.orep .back {
  background: ${C.surface}; border: 1px solid ${C.line}; color: ${C.ink};
  padding: 9px 18px; border-radius: 10px; font-size: 14px; font-weight: 600;
  cursor: pointer; font-family: inherit;
}
.orep .back:hover { background: #f8fafc; }

.orep .panel {
  background: ${C.surface}; border: 1px solid ${C.line};
  border-radius: 14px; padding: clamp(14px, 3vw, 22px); margin-bottom: 16px;
}
.orep .panel-head {
  display: flex; align-items: baseline; justify-content: space-between;
  gap: 12px; flex-wrap: wrap; margin-bottom: 14px;
}
.orep .panel-head h3 { margin: 0; font-size: 16px; font-weight: 700; }
.orep .panel-note { color: ${C.muted}; font-size: 13px; }

/* الفلاتر */
.orep .f-grid {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 14px; margin-bottom: 18px;
}
.orep .field { display: flex; flex-direction: column; gap: 6px; }
.orep .field > span { font-size: 13px; font-weight: 600; color: #475569; }
.orep .inp {
  width: 100%; box-sizing: border-box; height: 42px; padding: 0 12px;
  border: 1px solid ${C.line}; border-radius: 10px; background: #fff;
  font-size: 15px; font-family: inherit; color: ${C.ink};
}
.orep .inp:focus {
  outline: none; border-color: ${C.sells};
  box-shadow: 0 0 0 3px rgba(2,132,199,.14);
}
.orep .react-datepicker-wrapper { width: 100%; }

.orep .f-chips {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px; padding-top: 4px; margin-bottom: 18px;
}
.orep .f-title {
  display: block; font-size: 13px; font-weight: 600; color: #475569; margin-bottom: 8px;
}
.orep .chip-row { display: flex; flex-wrap: wrap; gap: 8px; }
.orep .chip {
  border: 1px solid ${C.line}; background: #f8fafc; color: #475569;
  padding: 8px 14px; border-radius: 999px; font-size: 13.5px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background .15s, color .15s, border-color .15s;
}
.orep .chip:hover { background: #f1f5f9; }
.orep .chip-on {
  background: ${C.ink}; border-color: ${C.ink}; color: #fff;
}
.orep .chip:focus-visible, .orep .back:focus-visible, .orep .go:focus-visible,
.orep .sortable:focus-visible { outline: 2px solid ${C.sells}; outline-offset: 2px; }

.orep .go {
  width: 100%; border: none; border-radius: 12px; background: ${C.ink}; color: #fff;
  padding: 14px 18px; font-size: 15.5px; font-weight: 700; cursor: pointer;
  font-family: inherit; display: flex; align-items: center; justify-content: center; gap: 10px;
}
.orep .go:hover:not(:disabled) { background: #1e293b; }
.orep .go:disabled { background: #94a3b8; cursor: not-allowed; }
.orep .spinner {
  width: 16px; height: 16px; border: 2px solid rgba(255,255,255,.35);
  border-top-color: #fff; border-radius: 50%; animation: orep-spin .8s linear infinite;
}
@keyframes orep-spin { to { transform: rotate(360deg); } }

.orep .err {
  margin: 12px 0 0; padding: 10px 14px; border-radius: 10px;
  background: #fef2f2; color: #b91c1c; font-size: 14px; border: 1px solid #fecaca;
}

/* الكروت */
.orep .kpi-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; margin-bottom: 16px;
}
.orep .kpi {
  background: ${C.surface}; border: 1px solid ${C.line}; border-top: 3px solid;
  border-radius: 14px; padding: 18px 16px; display: flex; flex-direction: column; gap: 6px;
}
.orep .kpi-label { font-size: 13.5px; font-weight: 600; color: ${C.muted}; }
.orep .kpi-value {
  font-size: clamp(22px, 4.4vw, 32px); font-weight: 800; letter-spacing: -.5px;
  font-variant-numeric: tabular-nums; line-height: 1.15;
}
.orep .kpi-sub { font-size: 12px; color: #94a3b8; }

.orep .meta-row {
  display: grid; grid-template-columns: repeat(5, 1fr); gap: 10px; margin-bottom: 16px;
}
.orep .meta {
  background: ${C.surface}; border: 1px solid ${C.line}; border-radius: 12px;
  padding: 12px 14px; display: flex; align-items: center; justify-content: space-between; gap: 8px;
}
.orep .meta span { font-size: 13px; color: ${C.muted}; }
.orep .meta strong { font-size: 17px; font-variant-numeric: tabular-nums; }

/* أجور التوصيل حسب الشركة */
.orep .mini-btn {
  border: 1px solid ${C.line}; background: #f8fafc; color: #475569;
  padding: 7px 13px; border-radius: 9px; font-size: 13px; font-weight: 600;
  cursor: pointer; font-family: inherit;
}
.orep .mini-btn:hover { background: #f1f5f9; color: ${C.ink}; }
.orep .mini-btn:focus-visible { outline: 2px solid ${C.sells}; outline-offset: 2px; }
.orep .top-hint { margin: -6px 0 14px; font-size: 12.5px; color: #94a3b8; }

.orep .ship-head, .orep .ship-row {
  display: grid;
  grid-template-columns: minmax(110px, 1.6fr) .8fr .8fr .9fr 1.1fr 1.2fr 1.1fr;
  gap: 10px; align-items: center;
}
.orep .ship-head {
  font-size: 12.5px; font-weight: 700; color: ${C.muted};
  padding: 0 4px 10px; border-bottom: 1px solid ${C.line};
}
.orep .ship-row { padding: 10px 4px; border-bottom: 1px solid #f1f5f9; }
.orep .ship-row:last-of-type { border-bottom: none; }
.orep .ship-name { font-size: 14.5px; font-weight: 600; }
.orep .ship-n { font-size: 14px; font-variant-numeric: tabular-nums; color: #475569; }
.orep .ship-total {
  font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; color: ${C.cost};
}
.orep .inp.small { height: 38px; padding: 0 10px; font-size: 14px; }

.orep .ship-sum {
  display: flex; flex-wrap: wrap; gap: 10px 26px; justify-content: flex-end;
  margin-top: 16px; padding-top: 14px; border-top: 2px solid ${C.line};
  font-size: 13.5px; color: ${C.muted};
}
.orep .ship-sum b {
  color: ${C.ink}; font-variant-numeric: tabular-nums; font-size: 16px; margin-inline-start: 6px;
}

/* نسبة الراجع */
.orep .rate-body {
  display: grid; grid-template-columns: minmax(150px, 200px) 1fr; gap: 22px; align-items: center;
}
.orep .rate-figure { display: flex; flex-direction: column; gap: 4px; }
.orep .rate-figure strong {
  font-size: clamp(30px, 6vw, 44px); font-weight: 800; letter-spacing: -1px;
  font-variant-numeric: tabular-nums; line-height: 1;
}
.orep .rate-figure span { font-size: 13px; color: ${C.muted}; }
.orep .rate-bar {
  height: 10px; background: #f1f5f9; border-radius: 999px; overflow: hidden; margin-bottom: 10px;
}
.orep .rate-bar span { display: block; height: 100%; }
.orep .rate-note { margin: 0; font-size: 13.5px; color: #475569; }

/* الشريط */
.orep .bar {
  display: flex; height: 16px; border-radius: 999px; overflow: hidden;
  background: #f1f5f9; margin-bottom: 14px;
}
.orep .bar span { display: block; height: 100%; }
.orep .legend { display: flex; flex-wrap: wrap; gap: 8px 22px; }
.orep .legend-item {
  display: flex; align-items: center; gap: 8px; font-size: 13.5px; color: #475569;
}
.orep .legend-item i { width: 10px; height: 10px; border-radius: 3px; display: inline-block; }
.orep .legend-item b { font-variant-numeric: tabular-nums; color: ${C.ink}; }
.orep .legend-item em { font-style: normal; color: #94a3b8; font-size: 12.5px; }
.orep .warn { margin: 14px 0 0; font-size: 13.5px; color: ${C.spend}; }

/* الجدول */
.orep .table-wrap { overflow-x: auto; }
.orep .tbl { width: 100%; border-collapse: collapse; }
.orep .tbl th, .orep .tbl td {
  text-align: right; padding: 12px 10px; border-bottom: 1px solid #eef2f7; font-size: 14.5px;
}
.orep .tbl th {
  font-size: 13px; font-weight: 700; color: ${C.muted};
  border-bottom: 1px solid ${C.line}; white-space: nowrap;
}
.orep .tbl .sortable { cursor: pointer; user-select: none; }
.orep .tbl .sortable:hover { color: ${C.ink}; }
.orep .tbl tbody tr:hover { background: #f8fafc; }
.orep .tbl .num { text-align: left; font-variant-numeric: tabular-nums; }
.orep .tbl .strong { font-weight: 700; }
.orep .tbl .dim { color: #94a3b8; font-size: 13px; }
.orep .card-list { display: none; }

/* المصاريف */
.orep .spend-list { display: flex; flex-direction: column; gap: 14px; }
.orep .spend-top {
  display: flex; align-items: baseline; justify-content: space-between; gap: 12px; margin-bottom: 6px;
}
.orep .spend-name { font-size: 14.5px; font-weight: 600; }
.orep .spend-amount { font-size: 15px; font-weight: 700; font-variant-numeric: tabular-nums; color: ${C.spend}; }
.orep .spend-bar { height: 8px; background: #f1f5f9; border-radius: 999px; overflow: hidden; }
.orep .spend-bar span { display: block; height: 100%; background: ${C.spend}; opacity: .75; }
.orep .spend-count { font-size: 12px; color: #94a3b8; margin-top: 4px; display: block; }

.orep .empty, .orep .start p { margin: 0; color: ${C.muted}; font-size: 14.5px; }
.orep .start { text-align: center; padding: 44px 20px; }
.orep .hint { margin: 16px 0 0; font-size: 12.5px; color: #94a3b8; }
.orep .hint code {
  background: #f1f5f9; padding: 1px 5px; border-radius: 4px; font-size: 12px; direction: ltr; display: inline-block;
}

/* ── الموبايل ─────────────────────────────────────────── */
@media (max-width: 900px) {
  .orep .kpi-grid { grid-template-columns: repeat(2, 1fr); }
  .orep .meta-row { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 620px) {
  .orep .rate-body { grid-template-columns: 1fr; gap: 14px; }
}
@media (max-width: 768px) {
  .orep .table-wrap { display: none; }
  .orep .card-list { display: flex; flex-direction: column; gap: 8px; }

  /* جدول الشركات يتحوّل بطاقات */
  .orep .ship-head { display: none; }
  .orep .ship-row {
    grid-template-columns: 1fr 1fr; gap: 10px 12px;
    border: 1px solid ${C.line}; border-radius: 12px;
    padding: 14px; margin-bottom: 10px; background: #f8fafc;
  }
  .orep .ship-row > span { display: flex; flex-direction: column; gap: 4px; }
  .orep .ship-row > span::before {
    content: attr(data-l); font-size: 11.5px; color: #94a3b8; font-weight: 600;
  }
  .orep .ship-name { grid-column: 1 / -1; }
  .orep .ship-sum { justify-content: flex-start; flex-direction: column; gap: 8px; }
  .orep .mini {
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    padding: 12px 14px; border: 1px solid ${C.line}; border-radius: 10px; background: #f8fafc;
  }
  .orep .mini-name { font-size: 14px; font-weight: 600; }
  .orep .mini-count {
    font-size: 16px; font-weight: 800; font-variant-numeric: tabular-nums; color: ${C.sells};
  }
  .orep .inp { font-size: 16px; }
  .orep .chip { padding: 9px 15px; font-size: 14px; }
  .orep .legend { gap: 8px 16px; }
}
@media (max-width: 460px) {
  .orep .kpi-grid { grid-template-columns: 1fr 1fr; gap: 10px; }
  .orep .kpi { padding: 14px 12px; }
  .orep .meta-row { grid-template-columns: 1fr; }
  .orep .head { align-items: center; }
  .orep .back { padding: 8px 14px; font-size: 13px; }
}

@media (prefers-reduced-motion: reduce) {
  .orep * { transition: none !important; animation: none !important; }
}
`;

export default OrdersReports;
